import React, { useContext, useState, createContext } from 'react'
import { navigate } from 'gatsby'
import { Context } from '../context/app-context'
import userSessionStorage from '../utils/userSessionStorage'
import { getEdad } from '../utils/date'
import GameServices from '../services/game-service'
import { concourseId, gameId } from '../constants/activity-constants'

interface IPlay {
  handlePlay: (talk?: boolean) => Promise<void>
  handleLogin: () => void
  participations: number
  firstPromotionalKey: boolean
  lives: number
  getLives: () => Promise<number | undefined>
  getAccumulationConcourse: () => Promise<void>
  test: () => void
}

const PlayContext = createContext<IPlay>({} as any)

const useProviderPlay = () => {
  const { dispatch } = useContext(Context)
  const session = new userSessionStorage()

  const [participations, setParticipations] = useState<number>(0)
  const [firstPromotionalKey, setFirstPromotionalKey] = useState<boolean>(false)
  const [lives, setLives] = useState<number>(0)

  const test = () => {
    dispatch!({
      type: 'set-modal',
      modalActive: {
        type: 'keys',
        props: {
          close: () => {
            dispatch!({ type: 'clear-modal' })
          },
        },
      },
    })
  }

  const getAccumulationConcourse = async () => {
    let tokenId = session.getToken()?.idToken
    const config = {
      headers: tokenId
        ? {
            Authorization: tokenId,
          }
        : undefined,
    }

    await GameServices.getAccumulationConcourse(concourseId!, config).then(
      (res: any) => {
        if (res.status === 200) {
          setParticipations(res.data.participations)
          res.data.promotionalKeyUsed
            ? setFirstPromotionalKey(true)
            : setFirstPromotionalKey(false)
        }
      }
    )
  }

  const getLives = async () => {
    let tokenId = session.getToken()?.idToken
    const config = {
      headers: tokenId
        ? {
            Authorization: tokenId,
          }
        : undefined,
    }

    const res = await GameServices.getLives(gameId!, config)
    if (res.status === 200) {
      setLives(res.data.totalLives)
      return res.data.totalLives as number
    }
  }

  const handleLogin = () => {
    const userInfo = session.getUserInfo()
    if (!userInfo) {
      dispatch!({
        type: 'set-modal',
        modalActive: {
          type: 'login',
          props: {
            close: () => {
              dispatch!({ type: 'clear-modal' })
            },
            handleSuccess: () => {
              window.location.reload()
            },
          },
        },
      })
    }
  }

  const handlePlay = async (talk?: boolean) => {
    dispatch!({
      type: 'set-modal',
      modalActive: {
        type: 'keys',
        props: {
          close: () => {
            if (talk) {
              dispatch!({
                type: 'set-modal',
                modalActive: {
                  type: 'talk',
                  props: {
                    close: () => {
                      localStorage.removeItem('__hablemos')
                      dispatch!({ type: 'clear-modal' })
                      window.location.reload()
                    },
                  },
                },
              })
            } else {
              dispatch!({ type: 'clear-modal' })
              window.location.reload()
            }
          },
        },
      },
    })
  }

  return {
    handlePlay,
    handleLogin,
    participations,
    firstPromotionalKey,
    lives,
    getLives,
    getAccumulationConcourse,
    test,
  }
}

export const usePlayContext = () => useContext(PlayContext)

export const PlayProvider = ({ children }: { children: React.ReactNode }) => {
  const play = useProviderPlay()
  return <PlayContext.Provider value={play}>{children}</PlayContext.Provider>
}
